// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__maisonNeue_a3eb1f', '__maisonNeue_Fallback_a3eb1f'"},"className":"__className_a3eb1f","variable":"__variable_a3eb1f"};